//export const baseUrl = "https://panel.valiyev.dev/"
export const baseUrl = "https://panel.azeraudit.com/"
//export const baseUrl = "http://localhost:9974/"
